import {
  Box,
  Fade,
  Typography,
} from '@mui/material'
import { CDN_PATH } from 'src/constants/global'
import styles from './Loading.scss'

interface LoadingStepProps {
  loading: boolean
  message: string
  transitionDelay: string
}

const LoadingStep = ({ loading, message, transitionDelay }: LoadingStepProps): JSX.Element => (
  <Fade
    in={loading}
    timeout={1500}
    style={{ transitionDelay }}
  >
    <Box className={styles.loadingStep}>
      <Box className={styles.loadingStepIcon}>
        <img src={`${CDN_PATH}/images/checkbox-icon.svg`} height="30" width="30" alt="Checkbox" />
      </Box>
      <Typography variant="h4Bold" color="primary.main">{message}</Typography>
    </Box>
  </Fade>
)

export default LoadingStep
